module.exports = __webpack_public_path__ + "img/zeroEight.c2ded0bf.png";